import React, { Component } from 'react'
import Button from '../Button'
import { VEHICLE_TYPE } from 'utils/constants';
import './CardSeller.scss'

export default class CardSeller extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate() {
        if (!this.props.showButtonPhone)
            document.querySelectorAll('.CardSeller__phone__number').forEach(function (item) {
                item.classList.add('CardSeller__phone__number--active');
            });
        if (this.props.loading)
            document.querySelectorAll('.CardSeller__phone__view').forEach(function (item) {
                item.classList.add('CardSeller__phone__view--loading');
            });
    }
    render() {
        return (
            <div className={'CardSeller CardSeller--private'}>
                <div className={'CardSeller__title'}>
                    <div className={'CardSeller__title__wrapper'}>
                        <h2 id={'VehicleSellerPrivateName'} className={'CardSeller__title__name'}>{this.props.data.Name}</h2>
                        <span id={'VehicleSellerPrivateState'} className={'CardSeller__title__state'}>{`${this.props.data.City}, ${this.props.data.UF}`}</span>
                    </div>
                </div>       
                {
                    this.props.data.ShowPhone ? 
                    (
                        VEHICLE_TYPE.car == this.props.vehicleType ?
                            this.props.data.Phone && this.props.data.Phone.length > 0 ?
                                <div id={'VehicleSellerPrivateBoxPhone'} className={'CardSeller__phone'}>
                                    <div className={'CardSeller__box__phone'}>
                                        {
                                            this.props.showButtonPhone ?
                                                <strong id={'VehicleSellerPrivatePhone'} className={'CardSeller__phone__number'}>
                                                    <small className={'CardSeller__phone__number__ddd'}>{this.props.data.Phone[0].ddd}</small>{this.props.data.Phone[0].number}
                                                </strong>
                                                :
                                                this.props.phonesDetail ? this.props.phonesDetail.map((element, key) => {
                                                    return <strong key={key} id={'VehicleSellerPrivatePhone_' + key} className={'CardSeller__phone__number'}>
                                                        <small className={'CardSeller__phone__number__ddd'}>{element.ddd}</small>{element.number}
                                                    </strong>
                                                }) : undefined
                                        }
                                    </div>
                                    {
                                        this.props.showButtonPhone ?
                                            <Button
                                                className=' Button--green CardSeller__phone__view'
                                                name='CardSeller__phone__view'
                                                id='CardSellerPhoneViewPrivate'
                                                type='submit'
                                                onClick={this.props.seePhone}
                                            >
                                                {this.props.loading ? 'carregando...' : 'Ver telefone'}
                                            </Button>
                                            : undefined
                                    }
                                </div>
                                : undefined
                            : this.props.data.Phone && this.props.data.Phone.length ?
                                <div id={'VehicleSellerPrivateBoxPhone'} className={'CardSeller__phone'}>
                                    <div className={'CardSeller__box__phone'}>
                                        {
                                            this.props.data.Phone.map((element, key) => {
                                                return <strong key={key} id={'VehicleSellerPrivatePhone_' + key} className={'CardSeller__phone__number CardSeller__phone__number--active'}>
                                                    <small className={'CardSeller__phone__number__ddd'}>{element.ddd}</small>{element.number}
                                                </strong>
                                            })
                                        }
                                    </div>
                                </div>
                                : undefined
                    ) : undefined
                }
                <p id={'VehicleSellerPrivateTypeAd'} className={'a-type'}>{this.props.data.SellerTypeName}</p>
            </div>
        )
    }
}